import { createSlice } from '@reduxjs/toolkit';
import { GET_NEXT_APP } from '../../../actions-index';

// ---------------------------------------------------------------------------
// DashboardReducer slice
// ---------------------------------------------------------------------------
const dashboardSlice = createSlice({
  name: 'DashboardReducer',
  initialState: { committees: [], committeeMap: [], loading: false, error: null },
  reducers: {
    setCommitteeList(state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setCommitteeList } = dashboardSlice.actions;
export const DashboardReducer = dashboardSlice.reducer;

// ---------------------------------------------------------------------------
// InProgressReducer slice
// ---------------------------------------------------------------------------
const inProgressSlice = createSlice({
  name: 'InProgressReducer',
  initialState: { progress: [], loading: false, error: null },
  reducers: {
    setInProgress(state, action) {
      Object.assign(state, action.payload);
    },
  },
});

export const { setInProgress } = inProgressSlice.actions;
export const InProgressReducer = inProgressSlice.reducer;

// ---------------------------------------------------------------------------
// NextAppReducer slice
// ---------------------------------------------------------------------------
const nextAppInitialState = { nextApp: [], loading: false, error: null };

const nextAppSlice = createSlice({
  name: 'NextAppReducer',
  initialState: nextAppInitialState,
  reducers: {
    cleanupNextApp() {
      return nextAppInitialState;
    },
    setNextApp(state, action) {
      state.nextApp = {
        status: action.payload.status,
        ...action.payload,
        type: GET_NEXT_APP,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GET_NEXT_APP, (state, action) => {
      state.nextApp = {
        ...state.nextApp,
        status: action.payload.status,
        alert: action.payload.alert,
        type: GET_NEXT_APP,
      };
    });
  },
});

export const { cleanupNextApp, setNextApp } = nextAppSlice.actions;
export const NextAppReducer = nextAppSlice.reducer;

// ---------------------------------------------------------------------------
// SystemWideMessageReducer slice
// ---------------------------------------------------------------------------
function withFinalMessages(state) {
  return {
    ...state,
    finalMessages:
      state?.alert?.MESSAGE ??
      (state?.messages?.length > 0 && state.messages) ??
      '',
  };
}

const systemWideMessageSlice = createSlice({
  name: 'SystemWideMessageReducer',
  initialState: { type: 'SYSTEM_WIDE_MESSAGE', finalMessages: '' },
  reducers: {
    setSystemWideMessage(state, action) {
      const next = withFinalMessages({
        type: 'SYSTEM_WIDE_MESSAGE',
        ...state,
        alert: action?.payload?.alert ?? {},
        messageIds: action?.payload?.messageIds ?? [],
        messages: action?.payload?.messages ?? [],
        status: action?.payload?.status ?? {},
      });
      return next;
    },
    clearSystemWideMessage(state, action) {
      const next = withFinalMessages({
        type: 'SYSTEM_WIDE_MESSAGE',
        ...state,
        alert: {},
        messages: [],
        status: action?.payload?.status ?? {},
      });
      return next;
    },
  },
});

export const { setSystemWideMessage, clearSystemWideMessage } =
  systemWideMessageSlice.actions;
export const SystemWideMessageReducer = systemWideMessageSlice.reducer;
